import React from 'react';
import Grid from '@mui/material/Grid';

export default React.memo(Grid);
